import React, { useState, useEffect } from "react";
import { Controller } from "react-hook-form";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from "@mui/x-date-pickers";
import 'dayjs/locale/en-in';
import { TextField, Typography } from "@mui/material";
import dayjs from 'dayjs';

// Utility function to format date without time
const formatDate = (date) => {
  return dayjs(date).format('YYYY-MM-DD');
};

const DatePick = ({
  label,
  defaultValue,
  control,
  name,
  width,
  validation
}) => {
  const [reqDate, setReqDate] = useState(null);

  useEffect(() => {
    if (defaultValue) {
      setReqDate(dayjs(formatDate(defaultValue)));
    }
  }, [defaultValue]);

  return (
    <Controller
      name={name}
      defaultValue={reqDate}
      rules={{
        ...(validation?.required?.value && {
          validate: (value) => !!value || validation?.required?.message,
        }),
      }}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <div>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-in">
            <DatePicker
              label={label}
              value={value ? dayjs(value) : reqDate}
              sx={{ width: width ? width : "18.25vw", borderRadius: '1px' }}
              onChange={(event) => {
                if (event) {
                  const formattedDate = formatDate(event);
                  onChange(formattedDate);
                } else {
                  onChange(null);
                }
              }}
              renderInput={(params) => (
                <TextField
                  size="small"
                  {...params}
                  error={!!error}
                  helperText={error ? error.message : null}
                  sx={{ width: width ? width : "18.25vw", borderRadius: '1px' }}
                />
              )}
            />
          </LocalizationProvider>
          {error && (
            <Typography variant="caption" color="error">
              {error.message}
            </Typography>
          )}
        </div>
      )}
    />
  );
};

export default DatePick;
